import FormattedMessage from 'I18n/components/FormattedMessage';
import UICardSection from 'UIComponents/card/UICardSection';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import { createContext, useState } from 'react';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledCard = styled.div.withConfig({
  displayName: "UndoRedoProvider__StyledCard",
  componentId: "qe5wym-0"
})(({
  theme: _theme
}) => {
  const theme = _theme;
  return {
    position: 'fixed',
    top: '30%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '250px',
    height: '150px',
    zIndex: 1000,
    borderRadius: theme.borderRadius[100],
    background: theme.color['fill-surface-default'],
    boxShadow: '0px 0px 12px 0px #99acc2',
    // Styles previously applied by UICardWrapper
    marginBottom: theme.space[400],
    marginTop: theme.space[0],
    padding: theme.space[0],
    display: 'flex',
    flexDirection: 'column'
  };
});
export const UndoRedoContext = /*#__PURE__*/createContext({
  isRedoLoading: false,
  isUndoLoading: false,
  setIsRedoLoading: () => {},
  setIsUndoLoading: () => {}
});
export const UndoRedoProvider = ({
  children
}) => {
  const [isRedoLoading, setIsRedoLoading] = useState(false);
  const [isUndoLoading, setIsUndoLoading] = useState(false);
  return /*#__PURE__*/_jsxs(UndoRedoContext.Provider, {
    value: {
      isRedoLoading,
      isUndoLoading,
      setIsRedoLoading,
      setIsUndoLoading
    },
    children: [(isRedoLoading || isUndoLoading) && /*#__PURE__*/_jsx(StyledCard, {
      children: /*#__PURE__*/_jsx(UICardSection, {
        children: /*#__PURE__*/_jsx(UILoadingSpinner, {
          layout: "centered",
          label: isRedoLoading ? /*#__PURE__*/_jsx(FormattedMessage, {
            message: "automation.common.undoRedo.redoLoading"
          }) : /*#__PURE__*/_jsx(FormattedMessage, {
            message: "automation.common.undoRedo.undoLoading"
          }),
          showLabel: true
        })
      })
    }), children]
  });
};